export enum ModulosEnum {
    USUARIOS = "USUÁRIOS",
    REMESSAS = "REMESSAS",
    RETORNOS = "RETORNOS",
    LOTACOES = "LOTAÇÕES",
    LOCAL_PAGAMENTO = "LOCAL DE PAGAMENTO",
    INSTRUCOES_BANCARIAS = "INSTRUÇÕES BANCÁRIAS",
    FORMA_PAGAMENTO = "FORMA DE PAGAMENTO",
    CONTRIBUINTE = "CONTRIBUINTE",
    DADOS_FINANCEIROS = "DADOS FINANCEIROS",
    DADOS_PESSOAIS = "DADOS PESSOAIS",
    FICHA_FINANCEIRA = "FICHA FINANCEIRA",
    DEPENDENTES = "DEPENDENTES",
    MOVIMENTACOES = "MOVIMENTAÇÕES",
    CAIXA = "CAIXA",
    RELATORIOS_GERENCIAIS = "RELATÓRIOS GERENCIAIS",
    RELATORIO_MOVIMENTACOES = "RELATÓRIO DE MOVIMENTAÇÕES",
    RELATORIO_RECEBIMENTOS = "RELATÓRIO DE RECEBIMENTOS",
    RELATORIO_BOLETOS = "RELATÓRIO DE BOLETOS",
    RELATORIO_INADIMPLENCIA = "RELATÓRIO DE INADIMPLÊNCIA",
    DECLARACAO_RECEBIMENTO = "DECLARAÇÃO DE RECEBIMENTO",
    RELATORIO_COMPARACAO_VALORES_DADOS_FINANCEIROS = "RELATÓRIO DE COMPARAÇÃO DE VALORES DOS DADOS FINANCEIROS",
    CONSULTA_RAPIDA = "CONSULTA RÁPIDA",
    REAJUSTE_VALORES_FINANCEIROS = "REAJUSTE DE VALORES FINANCEIROS",



    DETALHES_CONTRIBUINTE = "DETALHES_CONTRIBUINTE",
    REMESSA_RETORNO = "REMESSA_RETORNO",
    CADASTROS_GERAIS = "CADASTROS GERAIS"
}
